export default __webpack_public_path__ + "static/line-008e4beeb488f9701d2a2e1c6fa8f75a.png";